import React from "react";

import CountdownWidget from "./CountdownWidget";
import { useSchedulePeriod } from "../../lib/schedule";
import Aside from "./Aside"
import Slideshow from "../Slideshow";
import Layout from "../Layout";

const buildSlides = (slidesArray, flashContest) => {
  let slides = slidesArray.filter(slide => slide?.image);
  if (flashContest?.image) {
    slides.splice(1, 0, flashContest);
  }
  return slides;
}

const Hero = ({ sweepstakes }) => {
  const period = useSchedulePeriod();

  // We enable hiding behavior only when the sweepstakes has not yet ended.
  const showAsideAbove = ["review", "open", "closing"].includes(period) && "phone";
  const isArchived = period === "archived";
  const slides = isArchived ? sweepstakes.slides.slice(0, 1) : buildSlides(sweepstakes.slides, sweepstakes.activeFlashContest);
  const slideVideo = isArchived ? null : sweepstakes.slideVideo;

  return (
    <Layout.FullWidth fold>
      <CountdownWidget sweepstakes={sweepstakes} />

      <Layout.FlexibleColumn span={[7,15]} breakpoint="belowLaptop" spaced $centered>
        <Slideshow slideVideo={slideVideo} slides={slides} width={880} aspectRatio={[16,9]} />
      </Layout.FlexibleColumn>

      <Layout.FixedColumn span={5} breakpoint="belowLaptop" showAbove={showAsideAbove} spaced>
        <Aside sweepstakes={sweepstakes} isArchived={isArchived} />
      </Layout.FixedColumn>
    </Layout.FullWidth>
  );
}

export default Hero;
